
<template>

    <span :DataType="m_Attribute.DataType"
              v-html="NewLabelText"
              class="Label"
              :class="CssClass" />
 
</template>
<script>
    import Utility from '@/Common/Utility'
    import TControlBase from '@/Common/TControlBase' 
 


    export default {



        data() {
            return { 

                ControlType: "Label",
                NewLabelText:"" ,
                labelText: "",

                m_Text:"",
                m_Options: [],

                m_Attribute: TControlBase.Attribute({
                            DataType: "text",
                            Nullable: false,
                            Options: []
                        })
                
            }
        }
        ,
        //props: ["value", "name", "DataType", "Attribute", "Options"],

        //Only EmptyText , ���I�� PlaceHolder
        ////props: ["value", "Name", "DataType", "Attribute", "OptionName",
        //    "ComplexOptionName",
        //    "CacheOption",
        //    "EmptyText", "Options"],

        props: ["EmptyText", ...TControlBase.BaseProps],

        computed: {
            CssClass: {
                get: function () {
                    let result = "";

                    if (this.m_Attribute != null && this.m_Attribute .CssClass != null) {
                        result = this.m_Attribute.CssClass;
                    }

                     

                    return result;
                }
            }
            ,
            
     
        }
        ,
        methods: {

            GetValue() {
                return this.m_Value;
            },

            OnValueChange(e) {
                this.$emit("input", e.target.value);
            },


            UpdateElementByAttribute() {
                let checkValues = [];
                let checkTexts = [];
                let foundOption = false;
                let i;
                 

                if ((this.m_Attribute.DataType + "").toLowerCase() == "date") {
                    if (this.value != null && this.value != "") {
                        this.labelText = Utility.GetDateText(this.value);
                        this.NewLabelText = this.labelText;
                    }

                }
                else if ((this.m_Attribute.DataType + "").toLowerCase() == "datetime") {
                    if (this.value != null && this.value != "") {
                        this.labelText = Utility.GetDateTimeText(this.value);
                        this.NewLabelText = this.labelText;

                    }
                }
                else if ((this.m_Attribute.DataType + "").toLowerCase() == "weekday") {
                     if (this.value != null && this.value != "") {
                         this.labelText = Utility.GetWeekDayText(this.value);
                         this.NewLabelText = this.labelText;
                    }
                }
                else {
                    
                    if (this.m_Attribute != null && this.m_Attribute.Options.length > 0) {
                        this.labelText = "";

                        
                        if (this.value != null && (this.value + "").indexOf(",") > 0) {
                            checkValues = this.value.split(",");

                            checkValues.forEach(
                                (value) => {
                                    let optionText;

                                    optionText = this.GetOptionText(value);

                                    checkTexts.push(optionText);

                                    //this.m_Attribute.Options.forEach(
                                    //    (option) => {
                                    //        if (option.Value == value) {
                                    //            checkTexts.push(option.Text);
                                    //        }
                                    //    }
                                    //);
                                }
                            );

                            this.labelText = checkTexts.join(",");

                            this.NewLabelText = checkTexts.join(",");
          
                            this.$forceUpdate();
                        }
                        else {
                            let optionText;

                            optionText = this.GetOptionText(this.value);

                            this.labelText = optionText;
                            this.NewLabelText = optionText;

                            //for (i = 0; i < this.m_Attribute.Options.length; i++) {
                            //    if ((this.value + "") === this.m_Attribute.Options[i].Value) {
                            //        //this.labelText = this.m_Attribute.Options[i].Text + "("+this.m_Attribute.Options[i].Value+")";
                            //        this.labelText = this.m_Attribute.Options[i].Text;
                            //        this.NewLabelText = this.m_Attribute.Options[i].Text;
                            //        foundOption = true;
                            //        break;
                            //    }
                            //}

                            //if (!foundOption) {
                            //    this.labelText = this.value;
                            //    this.NewLabelText = this.value;
                            //}

                            this.$forceUpdate();

                        }
                    }
                    else {
                        this.labelText = this.value;
                        this.NewLabelText = this.value;
                    }

                }

                
                if ((this.NewLabelText == "" || this.NewLabelText == null) && this.EmptyText != null) {
                    this.NewLabelText = this.EmptyText;
                    //this.CssClass = "Empty";
                    this.m_Attribute.CssClass = "Empty";
                }

                this.$forceUpdate();
            }
        },

        mounted() {

            this.DoOnMounted();

            //this.PrepareSoltOptions();
            //this.UpdateElementByAttribute();
            //this.$forceUpdate();

            //if (this.Options != null && this.Options.length > 0) {
            //    this.m_Attribute.Options.push(...this.Options);
            //    this.UpdateElementByAttribute();

            //    this.$forceUpdate();
            //}

            //if (this.name == "PromotionTag") {
            //    setTimeout(
            //        () => {
            //            alert(this.m_Attribute.Options.length)
            //        },
            //        2000
            //    )
            //}
        },
         
        created() {
            let dateTimeObj;
 


 
            TControlBase.call(this);


            if (this.value != null) {
                this.NewLabelText = this.value;
            }

            if (this.nullable == "false") {
                this.m_Attribute.Nullable = false;
            }
            else {
                this.m_Attribute.Nullable = true;
            }
            if (this.DataType != null) {
                this.m_Attribute.DataType = this.DataType;
            }

            if (this.Options != null) {
                this.m_Attribute.Options = this.Options;
            }
           
            if (this.Attribute != null) {
                Utility.SetNotNullAttributes(this, this.m_Attribute, this.Attribute);
                this.UpdateElementByAttribute();
            }
            else {
                if ((this.DataType + "").toLowerCase() == "date" || (this.DataType + "").toLowerCase() == "datetime" || (this.DataType + "").toLowerCase() == "weekday") {
                    if ((this.m_Attribute.DataType + "").toLowerCase() == "date") {
                        dateTimeObj = Date.parse(this.value + "");
                        if (!isNaN(dateTimeObj)) {
                            this.labelText = Utility.GetDateText(this.value);
                            this.NewLabelText = this.labelText;
                        }
                    }
                    else if ((this.m_Attribute.DataType + "").toLowerCase() == "datetime") {
                        dateTimeObj = Date.parse(this.value + "");
                        if (!isNaN(dateTimeObj)) {
                            this.labelText = Utility.GetDateTimeText(this.value);
                            this.NewLabelText = this.labelText;
                        }
                    }
                    else if ((this.m_Attribute.DataType + "").toLowerCase() == "weekday") {
 
                        dateTimeObj = Date.parse(this.value + "");
                        if (!isNaN(dateTimeObj)) {
                            this.labelText = Utility.GetWeekDayText(dateTimeObj);
                            this.NewLabelText = this.labelText;

                        }
                    }
                    this.UpdateElementByAttribute();
                }
                else {
                     

                    if (this.OptionName == null || this.OptionName == "") {
                        this.labelText = this.value;
                        this.NewLabelText = this.labelText;


                    }
                    else {
                        //debugger;

                    }

                    if (this.m_Attribute != null && this.m_Attribute.Options.length > 0) {
                        this.UpdateElementByAttribute();
                    }


                    this.UpdateElementByAttribute();
                 }
            }
        },
        watch: {
            value: function (newVal, oldVal) {
                let dateTimeObj;
                this.labelText = newVal;

       
                if ((this.m_Attribute.DataType + "").toLowerCase() == "date") {
                    dateTimeObj = Date.parse(newVal + "");
                    if (!isNaN(dateTimeObj)) {
                        this.labelText = Utility.GetDateText(newVal);
                    }
                }
                else if ((this.m_Attribute.DataType + "").toLowerCase() == "datetime") {
                    dateTimeObj = Date.parse(newVal + "");
                    if (!isNaN(dateTimeObj)) {
                        this.labelText = Utility.GetDateTimeText(newVal);
                    }
                }
                else if ((this.m_Attribute.DataType + "").toLowerCase() == "weekday") {
                 
                    dateTimeObj = Date.parse(newVal + "");
                    if (!isNaN(dateTimeObj)) {
                        this.labelText = Utility.GetWeekDayText(dateTimeObj);
                    }
                }
                else if (Utility.IsDateObject(newVal)) {
                    this.labelText = Utility.GetDateTimeText(newVal);
                }

 
                this.NewLabelText = this.labelText;
                this.UpdateElementByAttribute();
 

                this.OnNewValue(newVal); //TControlBase.OnNewValue
                
                this.$forceUpdate();
            },

            DataType: function (newVal, oldVal) {
                this.m_Attribute.DataType = newVal;
                this.UpdateElementByAttribute();
            },

            Attribute: function (newVal, oldVal) {
                Utility.SetNotNullAttributes(this, this.m_Attribute, newVal);
                this.UpdateElementByAttribute();
            },
            nullable: function (newVal, oldVal) {
            },

            Options: function (newVal, oldVal) {
                this.m_Attribute.Options = newVal;
                this.UpdateElementByAttribute();

                this.$forceUpdate();
            }


        }
    }
</script>
<style>
</style>
